import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import HelpIcon from '@material-ui/icons/Help';
import { useSnackbar } from 'notistack';

import { getListAllAPI } from '../../../services';
import {
  formatPorcentagem,
  TIPO_ALIQUOTA_IBS_CBS_FIXA,
  TIPO_ALIQUOTA_IBS_CBS_PADRAO,
  TIPO_ALIQUOTA_IBS_CBS_SEM_ALIQUOTA,
  TIPO_ALIQUOTA_IBS_CBS_UNIFORME_NACIONAL,
  TIPO_ALIQUOTA_IBS_CBS_UNIFORME_SETORIAL,
  formatDateDDMMYYYY,
} from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const DEFAULT_ID = -1;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const HtmlTooltip = withStyles((theme) => ({
  arrow: {
    color: '#f5f5f9',
  },
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 'none',
    fontSize: theme.typography.pxToRem(12),
    border: '3px solid black',
  },
}))(Tooltip);

function Campo({ label, value, dica = 'lalala' }) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        fontSize: '20px',
      }}
    >
      <span
        style={{
          fontWeight: 'bold',
        }}
      >{`${label}:`}</span>
      <span>{`${value}`}</span>
      <HtmlTooltip title={dica} arrow>
        <IconButton
          aria-label="delete"
          size="small"
          style={{ marginLeft: '10px' }}
        >
          <HelpIcon />
        </IconButton>
      </HtmlTooltip>
    </div>
  );
}

const mapaTipoAliquota = {
  [TIPO_ALIQUOTA_IBS_CBS_PADRAO]: 'Padrão',
  [TIPO_ALIQUOTA_IBS_CBS_UNIFORME_SETORIAL]: 'Uniforme Setorial',
  [TIPO_ALIQUOTA_IBS_CBS_UNIFORME_NACIONAL]: 'Uniforme Nacional',
  [TIPO_ALIQUOTA_IBS_CBS_FIXA]: 'Fixa',
  [TIPO_ALIQUOTA_IBS_CBS_SEM_ALIQUOTA]: 'Sem Alíquota',
};

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [id, setId] = useState(DEFAULT_ID);

  const [carregando, setCarregando] = useState(false);

  const [value, setValue] = React.useState(0);

  ///////////////////////////////////////

  const [dados, setDados] = useState({});

  ///////////////////////////////////////

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'tabela-c-class-trib',
        ['id', 'asc'],
        { id: [id] },
        [],
      );

      if (data.data.length > 0) {
        setId(data.data[0].id);
        setValue(0);
        setId(data.data[0].id);
        setCarregando(false);

        setDados({
          identificador: data.data[0].identificador,
          cst: data.data[0].cst,
          c_class_trib: data.data[0].c_class_trib,
          nome: data.data[0].nome,
          descricao: data.data[0].descricao,
          lc_redacao: data.data[0].lc_redacao,
          lc_214_25: data.data[0].lc_214_25,
          tipo_aliquota: data.data[0].tipo_aliquota,
          pRedIBS: data.data[0].pRedIBS,
          pRedCBS: data.data[0].pRedCBS,
          ind_gTribRegular: data.data[0].ind_gTribRegular ? 'SIM' : 'NÃO',
          ind_gCredPresOper: data.data[0].ind_gCredPresOper ? 'SIM' : 'NÃO',
          ind_gMonoPadrao: data.data[0].ind_gMonoPadrao ? 'SIM' : 'NÃO',
          ind_gMonoReten: data.data[0].ind_gMonoReten ? 'SIM' : 'NÃO',
          ind_gMonoRet: data.data[0].ind_gMonoRet ? 'SIM' : 'NÃO',
          ind_gMonoDif: data.data[0].ind_gMonoDif ? 'SIM' : 'NÃO',
          ind_gEstornoCred: data.data[0].ind_gEstornoCred ? 'SIM' : 'NÃO',
          dIniVig: data.data[0].dIniVig,
          dFimVig: data.data[0].dFimVig,
          DataAtualizacao: data.data[0].DataAtualizacao,
          indNFeABI: data.data[0].indNFeABI ? 'SIM' : 'NÃO',
          indNFe: data.data[0].indNFe ? 'SIM' : 'NÃO',
          indNFCe: data.data[0].indNFCe ? 'SIM' : 'NÃO',
          indCTe: data.data[0].indCTe ? 'SIM' : 'NÃO',
          indCTeOS: data.data[0].indCTeOS ? 'SIM' : 'NÃO',
          indBPe: data.data[0].indBPe ? 'SIM' : 'NÃO',
          indBPeTA: data.data[0].indBPeTA ? 'SIM' : 'NÃO',
          indBPeTM: data.data[0].indBPeTM ? 'SIM' : 'NÃO',
          indNF3e: data.data[0].indNF3e ? 'SIM' : 'NÃO',
          indNFSe: data.data[0].indNFSe ? 'SIM' : 'NÃO',
          indNFSeVia: data.data[0].indNFSeVia ? 'SIM' : 'NÃO',
          indNFCom: data.data[0].indNFCom ? 'SIM' : 'NÃO',
          indNFAg: data.data[0].indNFAg ? 'SIM' : 'NÃO',
          indNFGas: data.data[0].indNFGas ? 'SIM' : 'NÃO',
          indDERE: data.data[0].indDERE ? 'SIM' : 'NÃO',
        });
      } else {
        throw 'Esta Classsificação Fiscal não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        fullScreen
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          {`Classificação Fiscal ${dados.c_class_trib}`}
        </DialogTitle>
        <DialogContent dividers>
          <div style={{ height: '100%' }}>
            <Box
              display={{ xs: 'block', sm: 'flex' }}
              flexDirection="column"
              marginBottom="30px"
              height="100%"
            >
              {carregando ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '300px',
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <Box p="1em">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                  >
                    <Tab label="Geral" {...a11yProps(0)} />
                    <Tab label="Tags" {...a11yProps(1)} />
                  </Tabs>
                  <Box display="flex">
                    <Box flex={2} mr="1em">
                      <TabPanel value={value} index={0}>
                        <Box
                          flex={1}
                          style={{
                            padding: '10px',
                            border: '3px solid red',
                            borderRadius: '10px',
                            marginBottom: '20px',
                          }}
                        >
                          <Typography
                            variant="h6"
                            gutterBottom
                            style={{
                              color: 'red',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              textDecoration: 'underline',
                            }}
                          >
                            Geral
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '10px',
                            }}
                          >
                            <Campo label="CST" value={dados.cst} dica="" />
                            <Campo
                              label="Código cClassTrib"
                              value={dados.c_class_trib}
                              dica=""
                            />
                            <Campo
                              label="Nome cClassTrib"
                              value={dados.nome}
                              dica=""
                            />
                            <Campo
                              label="Descrição cClassTrib"
                              value={dados.descricao}
                              dica=""
                            />
                            <Campo
                              label="LC Redação"
                              value={dados.lc_redacao}
                              dica=""
                            />
                            <Campo
                              label="LC 214/25"
                              value={dados.lc_214_25}
                              dica=""
                            />
                            <Campo
                              label="Tipo de Aliquota"
                              value={mapaTipoAliquota[dados.tipo_aliquota]}
                              dica=""
                            />
                            <Campo
                              label="pRedIBS"
                              value={`${formatPorcentagem(dados.pRedIBS)}`}
                              dica=""
                            />
                            <Campo
                              label="pRedCBS"
                              value={`${formatPorcentagem(dados.pRedCBS)}`}
                              dica=""
                            />
                            <Campo
                              label="dIniVig"
                              value={`${formatDateDDMMYYYY(dados.dIniVig)}`}
                              dica=""
                            />
                            <Campo
                              label="dFimVig"
                              value={`${formatDateDDMMYYYY(dados.dFimVig)}`}
                              dica=""
                            />
                            <Campo
                              label="DataAtualizacao"
                              value={`${formatDateDDMMYYYY(
                                dados.DataAtualizacao,
                              )}`}
                              dica=""
                            />
                          </div>
                        </Box>
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                        <Box
                          flex={1}
                          style={{
                            padding: '10px',
                            border: '3px solid red',
                            borderRadius: '10px',
                            marginBottom: '20px',
                          }}
                        >
                          <Typography
                            variant="h6"
                            gutterBottom
                            style={{
                              color: 'red',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              textDecoration: 'underline',
                            }}
                          >
                            Geral
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '10px',
                            }}
                          >
                            <Campo
                              label="ind_gTribRegular"
                              value={dados.ind_gTribRegular}
                              dica=""
                            />
                            <Campo
                              label="ind_gCredPresOper"
                              value={dados.ind_gCredPresOper}
                              dica=""
                            />
                            <Campo
                              label="ind_gMonoPadrao"
                              value={dados.ind_gMonoPadrao}
                              dica=""
                            />
                            <Campo
                              label="ind_gMonoReten"
                              value={dados.ind_gMonoReten}
                              dica=""
                            />
                            <Campo
                              label="ind_gMonoRet"
                              value={dados.ind_gMonoRet}
                              dica=""
                            />
                            <Campo
                              label="ind_gMonoDif"
                              value={dados.ind_gMonoDif}
                              dica=""
                            />
                            <Campo
                              label="ind_gEstornoCred"
                              value={dados.ind_gEstornoCred}
                              dica=""
                            />

                            <Campo
                              label="indNFeABI"
                              value={dados.indNFeABI}
                              dica=""
                            />
                            <Campo
                              label="indNFe"
                              value={dados.indNFe}
                              dica=""
                            />
                            <Campo
                              label="indNFCe"
                              value={dados.indNFCe}
                              dica=""
                            />
                            <Campo
                              label="indCTe"
                              value={dados.indCTe}
                              dica=""
                            />
                            <Campo
                              label="indCTeOS"
                              value={dados.indCTeOS}
                              dica=""
                            />
                            <Campo
                              label="indBPe"
                              value={dados.indBPe}
                              dica=""
                            />
                            <Campo
                              label="indBPeTA"
                              value={dados.indBPeTA}
                              dica=""
                            />
                            <Campo
                              label="indBPeTM"
                              value={dados.indBPeTM}
                              dica=""
                            />
                            <Campo
                              label="indNF3e"
                              value={dados.indNF3e}
                              dica=""
                            />
                            <Campo
                              label="indNFSe"
                              value={dados.indNFSe}
                              dica=""
                            />
                            <Campo
                              label="indNFSeVia"
                              value={dados.indNFSeVia}
                              dica=""
                            />
                            <Campo
                              label="indNFCom"
                              value={dados.indNFCom}
                              dica=""
                            />
                            <Campo
                              label="indNFAg"
                              value={dados.indNFAg}
                              dica=""
                            />
                            <Campo
                              label="indNFGas"
                              value={dados.indNFGas}
                              dica=""
                            />
                            <Campo
                              label="indDERE"
                              value={dados.indDERE}
                              dica=""
                            />
                          </div>
                        </Box>
                      </TabPanel>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
